



































import moment from 'moment';
import { listFactory } from '@/main/pages';
import { formatDate } from '@/main/utils/dateFormatter';

import Vue from 'vue/types/umd';

import { NAME, SUPPLIER_MULTISELECT_LIMIT } from './constants';
import {  store } from './store/list';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';
import { apiProvider } from './api';


export default listFactory(NAME, store).extend({
	data() {
		return {
			outSourcingParameters: 'null' as string,
			supplierMultiSelectLimit: SUPPLIER_MULTISELECT_LIMIT,
			fromDate: 'InvoiceDateFrom',
			toDate: 'InvoiceDateTo',
		};
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopIds);
		},
	},
	methods: {
		async onWorkShopChange(workshopId: number) {
			if (workshopId !== undefined) {
				const { data } = await apiProvider.GetWarehouse(workshopId);
				this.dropdownList.WareHouseId = data;
			}
		},
		dealerLocationUpdate() {
			const result = {} as any;
			this.dropdownList.WorkshopId.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
		},
		wareHouseUpdate() {
			const result = {} as any;
			this.dropdownList.WareHouseId.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
		},
		
		dateValidation() {
			if (this.InvoiceDateFrom && this.InvoiceDateTo) {
				const fromDate = new Date(this.InvoiceDateFrom);
				const toDate = new Date(this.InvoiceDateTo);
				const Startdate = fromDate.getDate();
				const endtdate = toDate.getDate();
				const startMonth = fromDate.getMonth();
				const endMonth = toDate.getMonth();
				const startYear = fromDate.getFullYear();
				const endYear = toDate.getFullYear();
				if (startMonth !== endMonth || startYear !== endYear) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_DATETOFROM_MONTH_VALIDATION') });
					this.InvoiceDateFrom = null;
					this.InvoiceDateTo = null;
					return false;
				} if (Startdate > endtdate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					this.InvoiceDateTo = null;
					return false;
				}
			} else {
				return false;
			}
			return true;
		},
		async filterClick() {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.WorkshopIds,
				(columnsSeq) => ({
					WorkshopIds: this.WorkshopIds,
					InvoiceDateFrom: this.InvoiceDateFrom,
					InvoiceDateTo: this.InvoiceDateTo,
					ColumnSequence: columnsSeq.join(','),
					BrandIds: this.BrandIds,
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
					LocalSuppliersIds: this.LocalSuppliersIds
				}),
			);
		},
		async exportFun() {
			try {
				if (this.filter.WorkshopIds == null || this.filter.WorkshopIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
					const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
					this.startLoading();
					const outSourcingUrlParameters: string = this.GetOutSourcingParameters(this.InvoiceDateFrom, this.InvoiceDateTo, this.WorkshopIds, this.BrandIds, this.LocalSuppliersIds);
					if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
					await apiProvider.GetOutSourcingDetail(outSourcingUrlParameters, getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId), columnsSeq);
				}
				
			}
			finally {
				this.endLoading();
			}
		},
		GetOutSourcingParameters(InvoiceDateFrom: any, InvoiceDateTo: any, WorkshopIds: any, BrandIds: any, LocalSuppliersIds: any) {
			const formattedFrom = formatDate(InvoiceDateFrom);
			const formattedTo = formatDate(InvoiceDateTo);
			this.outSourcingParameters = "";
			this.outSourcingParameters = this.outSourcingParameters.concat(`InvoiceDateFrom=${formattedFrom}&InvoiceDateTo=${formattedTo}`);
			if (WorkshopIds.length > 0) {
				WorkshopIds.forEach((WorkshopIds: any) => {
					this.outSourcingParameters = this.outSourcingParameters.concat(`&workshopIds=${WorkshopIds}`);
				});
			}
			if (BrandIds.length > 0) {
				BrandIds.forEach((BrandId: any) => {
					this.outSourcingParameters = this.outSourcingParameters.concat(`&BrandIds=${BrandId}`);
				});
			}
			if (LocalSuppliersIds.length > 0) {
				LocalSuppliersIds.forEach((LocalSuppliersId: any) => {
					this.outSourcingParameters = this.outSourcingParameters.concat(`&LocalSuppliersIds=${LocalSuppliersId}`);
				});
			}
			return this.outSourcingParameters;
		},
	},

	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length !== 0) element[0].classList.remove('d-flex');
	},
});
